import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import { AuthProvider, useAuth, homeFor } from "@/context/AuthContext";
import { RequireRole } from "@/components/RequireRole";
import { FullScreenLoader } from "@/components/FullScreenLoader";
import { COMING_SOON_MODULES } from "@/config/navigation";
import AdminLayout from "@/layouts/AdminLayout";
import EmployeeLayout from "@/layouts/EmployeeLayout";
import Login from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ForceChangePassword from "@/pages/ForceChangePassword";
import Dashboard from "@/pages/admin/Dashboard";
import Employees from "@/pages/admin/Employees";
import Settings from "@/pages/admin/Settings";
import ComingSoonModule from "@/pages/admin/ComingSoonModule";
import MyDashboard from "@/pages/employee/MyDashboard";
import Clock from "@/pages/employee/Clock";
import MyHours from "@/pages/employee/MyHours";
import MyEarnings from "@/pages/employee/MyEarnings";
import Profile from "@/pages/employee/Profile";

const StartScreen = () => {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
};

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<StartScreen />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password" element={<ForceChangePassword />} />
            <Route path="/admin" element={<RequireRole role="admin"><AdminLayout /></RequireRole>}>
              <Route index element={<Dashboard />} />
              <Route path="employees" element={<Employees />} />
              <Route path="settings" element={<Settings />} />
              {COMING_SOON_MODULES.map((m) => (
                <Route key={m.key} path={m.path.replace("/admin/", "")} element={<ComingSoonModule />} />
              ))}
            </Route>
            <Route path="/portal" element={<RequireRole role="employee"><EmployeeLayout /></RequireRole>}>
              <Route index element={<MyDashboard />} />
              <Route path="clock" element={<Clock />} />
              <Route path="hours" element={<MyHours />} />
              <Route path="earnings" element={<MyEarnings />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
